import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "QuickStepActions"*/ "./lazyIndex"), { name: "QuickStepActions" });

export const lazyOnExecuteQuickStep: LazyAction<typeof lazyIndex.onExecuteQuickStep, typeof lazyModule> = new LazyAction(lazyModule, m => m.onExecuteQuickStep);
export const lazyOnExecuteQuickStepHotkey: LazyAction<typeof lazyIndex.onExecuteQuickStepHotkey, typeof lazyModule> = new LazyAction(lazyModule, m => m.onExecuteQuickStepHotkey);

// non lazy export
export { getIsQuickStepDisabled } from "./utils/getIsQuickStepDisabled";
export { getIsQuickStepDisabledForPopout } from "./utils/getIsQuickStepDisabledForPopout";
